export default "/images/mailchimp.svg?f75e1d7ee98b015d5ceb9b9c6216d2d0";